export class ResizeChangeInfo {
  constructor(
    public width: number = 0,
    public height: number = 0,
  ) {}
}
